import office from '@/taskpane/officejs/office-wrapper'
import { IObserver } from '@/taskpane/common/observer-pattern'
import broadcastMessageToPortals from '../messages/broadcast-message-to-portals'
import PersonInfo from '../models/person-info'
import OfficeObservable from './office-observable'
import { sendMessageToSidebarWithIdsAfterComposeChanges } from '../messages/send-message-to-sidebar-with-ids-after-compose-check'

export interface ItemRecipientChangeArgs {
  people: PersonInfo[]
  to: PersonInfo[]
  cc: PersonInfo[]
  bcc?: PersonInfo[]
}

export class RecipientsObservable extends OfficeObservable<Office.EmailAddressDetails[]> {
  public eventHandlerType = () => Office.EventType.RecipientsChanged
  public get = async () => office.people.get()
}

export default class RecipientsObserver implements IObserver<Office.EmailAddressDetails[]> {
  public async update(people: Office.EmailAddressDetails[]): Promise<void> {
    if (office.mode.isAppointment()) {
      broadcastMessageToPortals('ItemRecipientChange', await getEventItemRecipientChangeArgs(people))
    } else {
      const args = await getMailItemRecipientChangeArgs()
      const subject = await office.subject.get()
      sendMessageToSidebarWithIdsAfterComposeChanges('ItemRecipientChange', args, subject, args.people)
    }
  }
}

async function getEventItemRecipientChangeArgs(people: Office.EmailAddressDetails[]): Promise<ItemRecipientChangeArgs> {
  const [requiredAttendees, optionalAttendees] = await Promise.all([office.event.requiredAttendees(), office.event.optionalAttendees()])

  return {
    people: people,
    to: requiredAttendees,
    cc: optionalAttendees,
    bcc: [],
  }
}

async function getMailItemRecipientChangeArgs() {
  const [to, cc, bcc] = await Promise.all([office.mail.to(), office.mail.cc(), office.mail.bcc()])

  const people = to.concat(cc, bcc)

  return {
    people: people,
    to: to,
    cc: cc,
    bcc: bcc,
  }
}
